import * as model from "@/model/prd/productionPlan/MonthPlan";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.MonthPlan(), newFilter)
    .withStates({
        idReport: 2,
        locations: [],
        materials: [],
        qualitySpe: [],

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start
    .withActions({
         
         loadLocations(context) {
            context.dispatch("api/get", {
                    url: process.env.VUE_APP_MASTER_API_URL + "master-service/master" + "/location/findAll"
                }, { root: true })
                .then(function(data) {
                    context.commit("setLocations", data);
                })
        },
        loadMaterials(context) {
            context.dispatch("api/get", {
                    url: process.env.VUE_APP_MASTER_API_URL + "master-service/master" + "/material/findAll"
                }, { root: true })
                .then(function(data) {
                    context.commit("setMaterials", data);
                })
        },
        loadQualitySpe(context) {
            context.dispatch("api/get", {
                    url: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd" + "/qualitySpecification/findAll"
                }, { root: true })
                .then(function(data) {
                    context.commit("setQualitySpe", data);
                })
        },

        monthPlanGenerateShiftPlan(context, entity) {            
            context.dispatch("base/showLoading",{}, { root: true });
            context.dispatch("api/get", {
                    url: context.state.baseModuleUrl + "/monthPlan/generateShiftPlanByPlanId/" + entity.id
                }, { root: true })        
                .then(function() {  
                    context.dispatch("base/hideLoading",{}, { root: true });                   
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Sucess!",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    },{ root: true }).then(function() {
                        router.push( '/prd/shiftPlan' );
                        context.dispatch("api/get", {
                            url: context.state.baseModuleUrl + "/shiftPlan/findByMonthPlanId/" + entity.id
                        },{ root: true })
                        .then(response => {
                            //seting the values
                             {
                                 //调试语句，用console
                                //console.log(response.list);
                                context.commit('shiftPlan' + "/setRows", response.list, { root: true });                                    
                            }       
                        });
                    })
                })
                .catch(function(){
                    context.dispatch("base/hideLoading",{}, { root: true });    
                })
                       
         }
    })
    .withMutations({
        setLocations(state, locations) {
            state.locations = locations;
        },
        setMaterials(state, materials) {
            state.materials = materials;
        },
        setQualitySpe(state, qualitySpe) {
            state.qualitySpe = qualitySpe;
        }
    })
    .buildStore()



    